import { useContext } from 'react';
import { InitialStateContext } from '../context/InitialState';

export const useDefaultSearchQuery = () => {
  const { defaults } = useContext(InitialStateContext);
  return defaults;
};
